import type { SVGProps } from "react";

// Scan-frame corners around a scan line — Door Check-In's sidebar icon.
const QrScanIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 6.25V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H6.25M13.75 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V6.25M17.5 13.75V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H13.75M6.25 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V13.75"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.83333 10H14.1667" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" />
    </svg>
  );
};

export default QrScanIcon;
